import type { FC, PropsWithChildren, ReactElement } from 'react';

import { BackToGameConnected } from '@pp/core/src/components/backToGame/BackToGameConnected';
import { JurisdictionNL } from '@pp/core/src/components/compliance/JurisdictionNL';
import { Fullscreen } from '@pp/core/src/components/fullscreen/Fullscreen';
import { DrawerRoot } from '@pp/core/src/components/game/drawer/root/DrawerRoot';
// import { MiniLobbyConnected } from '@pp/core/src/components/miniLobby/MiniLobbyConnected';
import { VolumeRestorer } from '@pp/core/src/components/settings/VolumeRestorer';
// import { TooltipRoot } from '@pp/core/src/components/tooltip/TooltipRoot';
import { useInitializationSlice } from '@pp/core/src/store/slices/initialization/selectors';
import { useMasterVolumeControl } from '@pp/core/src/store/slices/settings/hooks/useVolumeControl';
import { BackToGameHolder } from '@pp/core/src/components/backToGame/BackToGameHolder';


import styles from './CrashGameBody.module.css';

export const CrashGameBody: FC<PropsWithChildren> = ({ children }): ReactElement => {
  const isReadyToRender = useInitializationSlice.getIsReadyToRender();
  useMasterVolumeControl();

  return (
    <>
      {/* <SessionExpiredConnected /> */}
      {isReadyToRender ? (
        <div className={styles.gameBody}>
          <div className={styles.gameBody__container}>{children}</div>
          <DrawerRoot />
          {/* <TooltipRoot /> */}
          <VolumeRestorer />
          {/* <MiniLobbyConnected /> */}
          <BackToGameHolder>
            <BackToGameConnected />
          </BackToGameHolder>
          <JurisdictionNL />
        </div>
      ) : null}
      <Fullscreen isReadyToRender={isReadyToRender} />
    </>
  );
};
